"use client";
import {
	ChevronFirst,
	ChevronLast,
	ChevronLeft,
	ChevronRight,
} from "lucide-react";
import { Button } from "../ui/button";
import { usePathname, useRouter } from "next/navigation";
import { env } from "@/env.mjs";

type SearchProps = {
	params: { [key: string]: string | string[] | undefined };
	total: number;
};

export default function PaginateButtons({ params, total }: SearchProps) {
	const pageSize = Number(env.NEXT_PUBLIC_SEARCH_SIZE ?? 20);
	const router = useRouter();
	const pathname = usePathname();
	const totalPages = Math.ceil(total / pageSize);
	const canNextPage = total >= pageSize;
	// const firstPage = () => {
	// 	params["page"] = 1;
	// 	router.push(`/search?${new URLSearchParams(params)}`);
	// };
	// const lastPage = () => {
	// 	params["page"] = totalPages;
	// 	router.push(`/search?${new URLSearchParams(params)}`);
	// };
	const previousPage = () => {
		let page = Number(params["page"] ?? 1) - 1;
		params["page"] = page == 0 ? 1 : page;
		if (
			pathname.includes("skills") ||
			pathname.includes("products-and-business")
		) {
			router.push(`${pathname}?${new URLSearchParams(params)}`);
		} else {
			router.push(`/search?${new URLSearchParams(params)}`);
		}
	};

	const nextPage = () => {
		params["page"] = Number(params["page"] ?? 1) + 1;
		if (
			pathname.includes("skills") ||
			pathname.includes("products-and-business")
		) {
			router.push(`${pathname}?${new URLSearchParams(params)}`);
		} else {
			router.push(`/search?${new URLSearchParams(params)}`);
		}
	};

	return (
		<div className="flex flex-col items-center justify-end space-x-2 py-4 px-4 min-[400px]:flex-row">
			<Button
				variant="ghost"
				size="sm"
				onClick={previousPage}
				disabled={Number(params["page"] ?? 1) == 1}>
				<ChevronLeft size={20} />
			</Button>
			<p className="font-semibold text-sm">
				Page {Number(params["page"] ?? 1)}
			</p>

			<div>
				<Button
					variant="ghost"
					size="sm"
					onClick={nextPage}
					disabled={!canNextPage}>
					<ChevronRight size={20} />
				</Button>
			</div>
		</div>
	);
}
